/**
 * Leitura da tela "Pastas" do escritório cliente (migration 20261030150000_atticus_pastas_escritorio.sql).
 *
 * Antes da liberação tudo chega MASCARADO do servidor (a vitrine de `pasta_entregas`); depois,
 * com o contato do lead que a liberação criou na org do escritório. A tela não mascara nada.
 */
import { supabase } from "@/integrations/supabase/client";
import type { PastaVitrine } from "@/features/atticus-rateio/entrega/api";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rpc = (fn: string, args: Record<string, unknown>) => (supabase.rpc as any)(fn, args);

export interface EtapaEscritorio {
  id: string;
  nome: string;
  ordem: number;
}

/** Cartão do quadro: a vitrine + onde a pasta está. `nome` é o parcial até a liberação. */
export interface PastaEscritorio extends PastaVitrine {
  stage_id: string;
  etapa_desde: string | null;
  nome: string | null;
}

export interface QuadroEscritorio {
  pipeline_id: string;
  entrada_stage_id: string | null;
  pagamento_stage_id: string | null;
  etapas: EtapaEscritorio[];
  pastas: PastaEscritorio[];
}

export interface PastaDadoCampo {
  label: string;
  valor: string;
}

/** A gaveta. `contato` é parcial e `dados` é vazio enquanto `liberado` for false. */
export interface PastaEscritorioDetalhe extends PastaVitrine {
  stage_id: string;
  etapa_nome: string | null;
  etapa_desde: string | null;
  contato: { nome: string | null; email: string | null; telefone: string | null };
  dados: PastaDadoCampo[];
}

/** Null quando a org não é escritório do rateio. */
export async function fetchQuadroEscritorio(orgId: string): Promise<QuadroEscritorio | null> {
  const { data, error } = await rpc("pasta_escritorio_quadro", { p_org_id: orgId });
  if (error) throw error;
  return (data as QuadroEscritorio | null) ?? null;
}

export async function fetchPastaEscritorio(dealId: string): Promise<PastaEscritorioDetalhe> {
  const { data, error } = await rpc("pasta_escritorio_pasta", { p_deal_id: dealId });
  if (error) throw error;
  return data as PastaEscritorioDetalhe;
}

/**
 * Move a pasta liberada entre as etapas do escritório. É o `update` comum de `deals` (RLS da org);
 * a trava `pasta_trava_*` recusa pasta não liberada e as etapas do sistema.
 */
export async function moverPasta(dealId: string, stageId: string): Promise<void> {
  const { error } = await supabase.from("deals").update({ stage_id: stageId }).eq("id", dealId);
  if (error) throw error;
}
